<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Nomor Model Database</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group label="Filter" label-for="filterInput" class="form-inline form-group-wrapper mb-3">
                    <div class="d-flex search-input-wrapper">

                        <b-form-input @keyup.enter="onFilter" class="mx-2" v-model="filter.filterTipe" name="filterTipe" type="search"
                            placeholder="Nama Tipe"></b-form-input>

                        <b-form-input @keyup.enter="onFilter"  class="mx-2" v-model="filter.filterMerk" name="filterMerk" type="search"
                            placeholder="Nama Merk"></b-form-input>

                        <b-form-input @keyup.enter="onFilter"  class="mx-2" v-model="filter.filterModel" name="filterModel" type="search"
                            placeholder="No. Model"></b-form-input>

                        <b-button class="mx-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter">
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <div>
                    <b-button v-if="menu.includes('EMD')" class="mb-3" variant="pgiBtn" name="promoAddBtn"
                        @click="inputModel">
                        <i class="fa fa-plus mr-2"></i>
                        Input No. Model
                    </b-button>
                    <b-button v-if="menu.includes('EMD')" variant="pgiBtn" class="mx-2 mb-3 download-btn"
                        @click="$bvModal.show('modal-confirm-download')" :disabled="isBusy">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </b-button>
                </div>
            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="model" :fields="fields" :no-local-sorting="false"
                @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data.
                </template>
                <template v-slot:cell(tipe)="row">
                    {{ row.item.tipe }}
                    <div class="text-muted text-small">{{ row.item.merk }}</div>
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ $helper.changeDateFormat(row.item.createdAt) }}
                    {{ $helper.changeDateFormatGetHour(row.item.createdAt) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" class="table-button delete mr-2" v-b-tooltip.hover title="Hapus" variant="danger"
                        @click="modalDelete(row.item.id)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button size="sm" class="table-button edit" @click="modalEdit(row.item)" v-b-tooltip.hover
                        title="Edit" name="merkBarangEditBtn">
                        <i class="fa fa-pencil-square-o"></i>
                    </b-button>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="filter.show" id="showItems" :options="PageOptions" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-input-model" title="Input No. Model" no-close-on-backdrop>
            <b-row>
                <b-col>
                    <b-form-group label="Jenis Barang">
                        <multiselect v-model="input.jenisBarang" :options="optElekJenis" :internal-search="true"
                            :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="Merk Barang">
                        <multiselect v-model="input.merkBarang" :disabled="optElekMerk.length == 0" :options="optElekMerk"
                            :internal-search="true" :allow-empty="false" deselect-label="" select-label="" label="name"
                            track-by="id" placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="Tipe Barang" id="gadaiTipeBarang" class="select-tipe-barang">
                        <multiselect id="gadaiTipeBarang" name="gadaiTipeBarang" v-model="input.tipeBarang"
                            :disabled="optElekTipe.length == 0" :options="optElekTipe" :internal-search="true"
                            :allow-empty="true" deselect-label="" select-label="" label="name" track-by="name"
                            placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="No. Model">
                        <b-row no-gutters>
                            <b-col>
                                <b-form-input v-model="input.modelNumber" name="noModel" maxlength="30"
                                    required></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="submit()">
                    {{ loading ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-model" title="Edit No. Model" no-close-on-backdrop>
            <p v-if="activeId != null">Tipe Barang : {{ activeId.tipe }}</p>
            <b-row>
                <b-col>
                    <b-form-group label="No. Model">
                        <b-row no-gutters>
                            <b-col>
                                <b-form-input v-model="input.modelNumber" name="noModel" maxlength="30"
                                    required></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="edit()">
                    {{ loading ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="modal-delete-model" title="Konfirmasi Hapus no. model Database" :isSubmitting="loading"
            desc="Apakah anda yakin untuk hapus no. model Database ini ?" @submit="onDelete" />


        <ModalConfirm id="modal-confirm-download" title="Confirm Download no. model Database"
            desc="Apakah anda yakin untuk mendownload no. model Database ini?" @submit="onDownloadOrder()" />
        <b-modal id="modal-download-model" centered title="Download no. model Database" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="loading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download No. Model Database
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'model-database',
    data() {
        return {
            menu: localStorage.getItem('menuChildren'),
            initStatus: 0,
            isBusy: true,
            filter: {
                show: 10,
                filterModel: null,
                filterTipe: null,
                filterMerk: null,
                sortBy: null,
                sortDesc: null
            },
            filePathDownload: null,
            activeId: null,
            fields: [
                { key: "tipe", label: "Tipe Barang" },
                { key: "modelNumber", label: "No. Model" },

                { key: "createdAt", label: "Ditambahkan Pada" },
                { key: "action", label: "Aksi" }
            ],
            statusPromo: [
                { id: 0, name: 'Pending' },
                { id: 1, name: 'Berjalan' },
                { id: 2, name: 'Selesai' },
            ],
            PageOptions: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            input: {
                modelNumber: null,
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
            },

            options: [
                { value: null, text: '--- Spek IMEI ---' },
                { value: 2, text: 'IMEI Resmi' },
                { value: 5, text: 'IMEI LN' },
            ],

            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],


            model: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.filter.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getModel = this.$axios.get("model-number-database/" + this.query).then(response => {
                this.model = response.data.data
                this.updateTotalItem(response.data.total)
            })

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
            })

            let getMerk = this.$axios.get("barang-merk/" + this.query).then(response => {
                this.options = response.data.data
            })

            Promise.all([getModel, getJenisElek, getMerk]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },


        //----------------- Fungsi Ambil Data Promo -----------------

        getModel() {
            this.toggleBusy()
            this.model = []

            if (this.filter.filterTipe != null) this.query = this.query + "&filterTipe=" + this.filter.filterTipe
            if (this.filter.filterMerk != null) this.query = this.query + "&filterMerk=" + this.filter.filterMerk
            if (this.filter.filterModel != null) this.query = this.query + "&filterModel=" + this.filter.filterModel

            this.$axios.get("model-number-database/" + this.query).then(response => {
                this.model = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange() {
            this.size = this.filter.show
            this.perPage = this.filter.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getModel()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getModel()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy == "persen") {
                this.filter.sortBy = "nominalPersen"
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            } else if (ctx.sortBy != "") {
                this.filter.sortBy = ctx.sortBy
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.filter.filterTipe = null
            this.filter.filterMerk = null
            this.filter.filterModel = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getModel()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getModel()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputModel() {
            this.input = {
                modelNumber: null,
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
            }
            this.$bvModal.show('modal-input-model')
        },

        submit() {
            if (this.$helper.isNullOrEmpty(this.input.jenisBarang) || this.$helper.isNullOrEmpty(this.input.merkBarang) ||
                this.$helper.isNullOrEmpty(this.input.tipeBarang) || this.$helper.isNullOrEmpty(this.input.modelNumber)
            ) {
                this.$helper.toastErr(this, "Mohon lengkapi data terlebih dahulu!")
                return
            }
            this.loading = true
            this.$axios.post("model-number-database/" + `?tipeId=${this.input.tipeBarang.id}&modelNumber=${this.input.modelNumber}`, { timeout: 300000 }).then(() => {
                this.input.modelNumber = ''
                this.input.jenisBarang = { id: null, name: null }

                this.loading = false
                this.getModel()
                this.$bvModal.hide('modal-input-model')
                this.$helper.toastSucc(this, "Data Berhasil Ditambahkan")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        modalDelete(id) {
            this.activeId = id
            this.$bvModal.show('modal-delete-model')
        },

        onDelete() {
            this.loading = true
            this.$axios.post(`model-number-database/delete/${this.activeId}`).then(() => {
                this.loading = false
                this.getModel()
                this.$bvModal.hide('modal-delete-model')
                this.$helper.toastSucc(this, "Data Berhasil Dihapus")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        resetInput() {
            this.input = {
                modelNumber: null,
                password: "",
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
            }
        },

        onDownloadOrder() {
            this.loading = true
            this.$bvModal.show('modal-download-model')
            this.$bvModal.hide('modal-confirm-download')
            setTimeout(() => { this.axiosDownloadExcel() }, 500)
        },

        axiosDownloadExcel() {
            this.$axios.get("model-number-database/download-excel").then(response => {
                this.filePathDownload = response.data.name
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        modalEdit(item) {
            this.input.modelNumber = item.modelNumber
            this.activeId = item
            this.$bvModal.show('modal-edit-model')
        },

        edit() {
            if (this.$helper.isNullOrEmpty(this.input.modelNumber)) {
                return this.$helper.toastErr(this, "Mohon isi No. Model!")
            }

            this.loading = true
            this.$axios.post("model-number-database/update" + `?id=${this.activeId.id}&modelNumber=${this.input.modelNumber}`, { timeout: 300000 }).then(() => {
                this.input.modelNumber = ''
                this.input.jenisBarang = { id: null, name: null }

                this.loading = false
                this.getModel()
                this.$bvModal.hide('modal-edit-model')
                this.$helper.toastSucc(this, "Data Berhasil Diubah")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        }
    },

    watch: {
    
        'input.jenisBarang': function (newVal) {
            this.optElekMerk = []
            this.input.merkBarang = { id: null, name: null }

            if (newVal == null) { return }

            if (newVal.id != undefined) {

                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optElekMerk = response.data
                })
            }
        },

        'input.merkBarang': function (newVal) {

            this.optElekTipe = []
            this.input.tipeBarang = null

            if (newVal.id == undefined) { return }

            if (newVal.id != undefined) {

                this.$axios.get(`barang-tipe-v2/merk/${newVal.id}`).then(response => {
                    this.optElekTipe = response.data.types
                })
            }

        },
    },


    created() {
        this.init()
        if (this.menu.includes('EMD')) {
            this.fields = [
                { key: "tipe", label: "Tipe Barang" },
                { key: "modelNumber", label: "No. Model" },
                { key: "createdAt", label: "Ditambahkan Pada" },
                { key: "action", label: "Aksi" }
            ]
        }
        else {
            this.fields = [
                { key: "tipe", label: "Tipe Barang" },
                { key: "modelNumber", label: "No. Model" },
                { key: "createdAt", label: "Ditambahkan Pada" },
            ]
        }
    }
}
</script>
